import HSwiperItem from './HSwiperItem.vue'

// 为组件提供 install 安装方法，供按需引入
HSwiperItem.install = function (Vue) {
    Vue.component(HSwiperItem.name, HSwiperItem)
}
  
// 默认导出组件
export default HSwiperItem